import classNames from "classnames";
import { CollapsibleContainer } from "../../../../Atoms/CollapsibleContainer";
import checkoutStyle from "../../Checkout.module.scss";
import s from "./CollapsibleFieldSet.module.scss";

type CollapsibleFieldsetProps = { label: string };
export default function CollapsibleFieldset({
  label,
  children,
}: React.PropsWithChildren<CollapsibleFieldsetProps>) {
  return (
    <div style={{ position: "relative" }}>
      <div className={s.Divider} />
      <CollapsibleContainer
        label={
          <legend
            className={checkoutStyle.BookingFormFieldsetLegend}
            style={{ backgroundColor: "white" }}
          >
            {label}
          </legend>
        }
        disableBorderBottom
        disableBorderTop
        summaryProps={{
          style: {
            height: 72,
          },
        }}
        arrowProps={{
          size: 28,
        }}
        collapsibleProps={{
          style: {
            marginBottom: 18,
          },
        }}
      >
        <fieldset
          className={classNames(
            checkoutStyle.BookingFormFieldset,
            checkoutStyle.Collapsible
          )}
        >
          <div className={checkoutStyle.BookingFormFieldsetFields}>
            {children}
          </div>
        </fieldset>
      </CollapsibleContainer>
    </div>
  );
}
